var Plugins = {}
import _isUndefined from 'lodash/isUndefined'
import _isEmpty from 'lodash/isEmpty'

Plugins.install = function (Vue, options) {
  Vue.prototype.fullScreenUrl = function (src) {
    return '/uploads/' + croppa.url(src, 2200, null, ['resize'])
  }

  Vue.prototype.thumbnailUrl = function (src) {
    return '/uploads/' + croppa.url(src, 800, null, ['resize'])
  }
  Vue.prototype.smallThumbnailUrl = function (src) {
    return '/uploads/' + croppa.url(src, 500, null, ['resize'])
  }
  Vue.prototype.splited = function (txt) {
    var chars = $.trim(txt).split(' ');
    return '<span>' + chars.join('</span> <span>') + '</span>';
  }  
  Vue.prototype.formatMeta = function (entity) {
    var seo = {
      title: '',
      keywords: '',
      description: '',
      descriptionTwitter: '',
      titleTwitter: '',
      descriptionFacebook: '',
      titleFacebook: '',
      image: '',
      imageTwitter: '',
      imageFacebook: '',
      linkCanonical: ''
    }

    if (!_isUndefined(entity.fields)) {
      const e = entity.fields
      
          // seo_canonical_link
        if (e.seo_canonical_link && !_isEmpty(e.seo_canonical_link.value)) {
            seo.linkCanonical = e.seo_canonical_link.value
        } else {
          seo.linkCanonical = window.location.href
        }
          // seo_description
        if (e.seo_description && !_isEmpty(e.seo_description.value)) {
            seo.description = e.seo_description.value
        }
          // seo_twitter_description
        if (e.seo_twitter_description && !_isEmpty(e.seo_twitter_description.value)) {
            seo.descriptionTwitter = e.seo_twitter_description.value
        } else {
          seo.descriptionTwitter = e.seo_description && e.seo_description.value ? e.seo_description.value : ''
        }
          // seo_facebook_description
        if (e.seo_facebook_description && !_isEmpty(e.seo_facebook_description.value)) {
            seo.descriptionFacebook = e.seo_facebook_description.value
        } else {
          seo.descriptionFacebook = e.seo_description && e.seo_description.value ? e.seo_description.value : ''
        }        
          // seo_keywords
        if (e.seo_keywords && !_isEmpty(e.seo_keywords.value)) {
            seo.keywords = e.seo_keywords.value
        }
          // seo_title
        if (e.seo_title && !_isEmpty(e.seo_title.value)) {
            seo.title = e.seo_title.value
        }
          // seo_twitter_title
        if(e.seo_twitter_title && !_isEmpty(e.seo_twitter_title.value)) {
          seo.titleTwitter = e.seo_twitter_title.value
        } else {
          seo.titleTwitter = e.seo_title && e.seo_title.value ? e.seo_title.value : ''
        }
          // seo_facebook_title
        if(e.seo_facebook_title && !_isEmpty(e.seo_facebook_title.value)) {
          seo.titleFacebook = e.seo_facebook_title.value
        } else {
          seo.titleFacebook = e.seo_title && e.seo_title.value ? e.seo_title.value : ''
        }
          // seo_image
        if (e.seo_image && !_isEmpty(e.seo_image.value)) {
            seo.image = e.seo_image.value
        }
          // seo_facebook_image
        if(e.seo_facebook_image && !_isEmpty(e.seo_facebook_image.value)) {
          seo.imageFacebook = e.seo_facebook_image.value
        } else {
          seo.imageFacebook = e.seo_image && e.seo_image.value ? e.seo_image.value : ''
        }
          // seo_twitter_image
        if(e.seo_twitter_image && !_isEmpty(e.seo_twitter_image.value)) {
          seo.imageTwitter = e.seo_twitter_image.value
        } else {
          seo.imageTwitter = e.seo_image && e.seo_image.value ? e.seo_image.value : ''
        }        
    }

    if (_isEmpty(seo.title)) {
      seo.title = entity.title
    }

    return seo
  }
}

export default Plugins